<template>
<div class="chapter">
<div class="inner_page">
<h2 class="AHD">Red Velvet Whoopie</h2>
<p class="INTRO1">Another firm favourite among whoopie aficionados.</p>
<h4 class="MLAHD">Ingredients…</h4>
<p class="ML-BL1-1st">•  115g (4oz) soft unsalted (sweet) butter</p>
<p class="ML-BL1">•  200g (7oz) caster (superfine) sugar</p>
<p class="ML-BL1">•  1 large (US extra large) egg</p>
<p class="ML-BL1">•  5ml (1 tsp) vanilla extract</p>
<p class="ML-BL1">•  5ml (1 tsp) white vinegar</p>
<p class="ML-BL1">•  30g (1oz) cocoa powder (unsweetened cocoa)</p>
<p class="ML-BL1">•  225ml (8 fl oz) buttermilk</p>
<p class="ML-BL1">•  5ml (1 tsp) bicarbonate of soda</p>
<p class="ML-BL1">•  240g (8<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span>oz) plain (all-purpose) flour</p>
<p class="ML-BL1-last">•  2.5ml (<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span> tsp) red paste food colour</p>
<p class="SbS1"><strong>1</strong> Preheat the oven to 180ºC (350ºF/Gas 4). Grease two whoopie pie tins with a little softened butter.</p>
<p class="SbS1"><strong>2</strong> Sift together the flour and bicarbonate of soda and set aside.</p>
<p class="SbS1"><strong>3</strong> In a separate bowl, cream the butter and sugar together until light and fluffy using an electric whisk or freestanding mixer.</p>
<p class="SbS1"><strong>4</strong> Add the egg and beat until well combined.</p>
<p class="SbS1"><strong>5</strong> In a small bowl, mix the cocoa, vanilla, vinegar and red paste food colour until you have a smooth paste, then mix in to the batter.</p>
<p class="SbS1"><strong>6</strong> Fold in half the flour mixture, followed by half the buttermilk. Repeat with remaining ingredients.</p>
<p class="SbS1"><strong>7</strong> Drop 1<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span> tbsp or a level small ice cream scoopful of batter into each well of the tins.</p>
<p class="SbS1"><strong>8</strong> Bake for approximately 12 minutes or until the whoopies feel just firm to the touch. Allow to cool in the tins for five minutes before transferring to a wire rack to cool completely.</p>
<div class="SBDIV">
<h4 class="TIP-AHD">Red or Dead…</h4>
<p class="TIP1">Don’t be afraid to add lots of colour – a red velvet whoopie can never be too red!</p>
</div>
<p class="Image"><img alt="" src="images/1100204_WHOOPY_1_012RE_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c06.vue?55831234